import React from "react";

type AddButtonProps = {
    onClick: () => void;
};

const RefreshButton: React.FC<AddButtonProps> = ({onClick}) => {
    return (
        <button
            className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition"
            onClick={onClick}
        >
            <svg
                className="w-5 h-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
            >
                <path
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 12a9 9 0 0 0-15.5-6.36M3 4v6h6
                       M3 12a9 9 0 0 0 15.5 6.36M21 20v-6h-6"
                />
            </svg>

            <span>Aggiorna</span>
        </button>
    );
};

export default RefreshButton;